import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import logo from '../assets/logo.png';
import './GoalAnimation.css';

function GoalAnimation({ onComplete, userName }) {
  useEffect(() => {
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 4000);

    return () => {
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className="lineup-animation-container">
      {/* Fundo com linhas dinâmicas */}
      <div className="dynamic-lines">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="line"
            initial={{ scaleX: 0, opacity: 0 }}
            animate={{ 
              scaleX: 1, 
              opacity: [0, 0.5, 0],
              x: [0, Math.random() * 100 - 50]
            }}
            transition={{
              duration: 1.5,
              delay: i * 0.05,
              ease: 'easeOut'
            }}
            style={{
              top: `${5 + i * 5}%`,
              left: Math.random() > 0.5 ? '0%' : 'auto',
              right: Math.random() > 0.5 ? 'auto' : '0%',
            }}
          />
        ))}
      </div>

      {/* Logo do clube */}
      <motion.div
        className="lineup-logo"
        initial={{ scale: 0, rotate: -180, opacity: 0 }}
        animate={{ scale: 1, rotate: 0, opacity: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
      >
        <motion.img
          src={logo}
          alt="Fortaleza"
          animate={{
            filter: [
              'drop-shadow(0 0 20px rgba(0, 51, 102, 0.8))',
              'drop-shadow(0 0 40px rgba(227, 6, 19, 0.8))',
              'drop-shadow(0 0 20px rgba(0, 51, 102, 0.8))',
            ],
          }}
          transition={{ duration: 2, repeat: Infinity }}
        />
      </motion.div>

      {/* Nome do usuário */}
      <motion.div
        className="lineup-name"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5, ease: 'easeOut' }}
      >
        <motion.div
          className="name-line top"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        />
        <motion.h1
          initial={{ opacity: 0, letterSpacing: '20px' }}
          animate={{ opacity: 1, letterSpacing: '5px' }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          {userName}
        </motion.h1>
        <motion.div
          className="name-line bottom"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        />
      </motion.div>

      {/* Texto de acesso */}
      <motion.div
        className="lineup-access"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.5 }}
      >
        <motion.p
          animate={{
            opacity: [1, 0.7, 1],
          }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          ACESSO AUTORIZADO
        </motion.p>
      </motion.div>

      {/* Partículas decorativas */}
      {[...Array(30)].map((_, i) => (
        <motion.div
          key={`particle-${i}`}
          className="particle"
          initial={{
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
            scale: 0,
            opacity: 1,
          }}
          animate={{
            x: Math.random() * window.innerWidth,
            y: Math.random() * window.innerHeight,
            scale: [0, 1, 0],
            opacity: [0, 0.8, 0],
          }}
          transition={{
            duration: 2,
            delay: 1 + Math.random() * 0.5,
            ease: 'easeOut',
          }}
        />
      ))}

      {/* Vinheta lateral */}
      <motion.div
        className="vignette left"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      />
      <motion.div
        className="vignette right"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      />
    </div>
  );
}

export default GoalAnimation;
